export default {
    title: "",
    unavailable: "Este producto ya no está disponible."
}